<template>
  <b-card>
    <div slot="header">
      <h4 class="mr-5 pull-left">{{$t('TRANSACTIONS')}}</h4>
      <new-button :c_permission="C_TRANSACTION_NEW_BUTTON" button_type="new" variant="primary" class="pull-right" @click="aside=true">
       Nova transakcija
      </new-button>
    </div>
    <app-aside  v-model="aside">
      <template slot="header">Nova transakcija</template>
      <br/>
      <transaction-form @success="closeAndReload"/>
    </app-aside>
    <app-aside  v-model="editAside">
      <template slot="header">Uredi transakciju</template>
      <br/>
      <transaction-form :transaction-object="editTransactionObject" @success="closeAndReload"/>
    </app-aside>
    <div class="position-relative">
      <form class="mb-4" @submit.prevent="search" @reset.prevent="resetForm">
        <b-row>
          <b-col md="2" class="">
            <label class="label-text">Godina</label>
            <b-select :options="year_options"
                      type="select"
                      v-model="filter.year">
            </b-select>
          </b-col>

          <b-col md="2" class="">
            <label class="label-text">Vrsta transakcije</label>
            <b-select :options="type_options"
                      type="select"
                      v-model="filter.type">
            </b-select>
          </b-col>
          <b-col md="4" class="" v-if="checkPermission(C_CLIENT_SEARCH)">
            <label class="label-text">Klijent</label>
            <search-client v-model="clientSearch"/>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="d-inline-flex">
            <app-submit :disabled="loading" :loading="loader_submit" class="mr-3" variant="primary"  button_type="search"> {{$t('SEARCH')}}</app-submit>
            <app-submit :disabled="loading" :loading="loader_reset" class="mr-3" variant="outline-primary" type="reset" button_type="reset">{{$t('RESET')}}</app-submit>
          </b-col>
        </b-row>
      </form>
      <div v-if="items && items.length > 0" class="table-container">
        <b-table class="applicant_table animated fadeIn"  responsive hover  :fields="fields" :items="items" primary-key="id" :busy="loading">
          <template v-slot:cell(date) = "data">
            {{data.item.date | formatDate}}
          </template>
          <template v-slot:cell(type) = "data">
            {{data.item.type === 1 ?  'Kupovina' : data.item.type === 2 ?  'Prodaja' : ''}}
          </template>
          <template v-slot:cell(amount) = "data">
            {{data.item.amount | formatDecimals(2)}}
          </template>
          <template v-slot:cell(number_of_quota) = "data">
            {{data.item.number_of_quota | formatDecimals(6)}}
          </template>
          <template v-slot:cell(price_of_quota) = "data">
            {{data.item.price_of_quota | formatDecimals(4)}}
          </template>
          <template v-slot:cell(output_fee) = "data">
            {{data.item.output_fee| formatDecimals(2)}}
          </template>
          <template v-slot:cell(sum_quota) = "data">
            {{data.item.sum_quota| formatDecimals(6)}}
          </template>
          <template v-slot:cell(edit)="data">
            <app-button class="pull-right"
                        @click="edit(data.item)"
                        :c_permission="C_TRANSACTION_EDIT_BUTTON"
                        size="sm"
                        variant="link">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </app-button>
          </template>
        </b-table>
        <b-pagination
          size="sm"
          :prev-text="$t('PREV')"
          :next-text="$t('NEXT')"
          :total-rows="total"
          :per-page="perPage"
          v-model="currentPage">
        </b-pagination>

      </div>
    </div>
  </b-card>
</template>

<script>
import AppAside from '@/components/app/form/AppAside'
import NewButton from '@/components/app/AppButton'
import AppButton from "@/components/app/AppButton";
import routeNames from '@/router/routeNames'
import {getTransactionList} from "@/services/transaction";
import TransactionForm from "@/components/transaction/TransactionForm";
import {formatDate, formatDecimals} from '@/filters/formatDates';
import AppSubmit from "@/components/app/AppSubmit";
import {C_TRANSACTION_EDIT_BUTTON, C_TRANSACTION_NEW_BUTTON} from "@/shared/component_permission";
import { mapGetters } from 'vuex';
import SearchClient from "@/components/client/SearchClient";
import {C_CLIENT_SEARCH} from '@/shared/component_permission';
import {toast} from "@/shared/plugins/toastr";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
export default {
  name: "index",
  mixins: [getErrorMessage],
  data(){
    return {
      fields: [
        {key: 'client.name', label: 'Klijent'},
        {key: 'date', label: 'Datum'},
        {key: 'type', label: 'Vrsta transakcije'},
        {key: 'amount', label: 'Iznos (KM)'},
        {key: 'number_of_quota', label: 'Broj udjela'},
        {key: 'price_of_quota', label: 'Cijena udjela (KM)'},
        {key: 'output_fee', label: 'Trošak izlazne naknade (KM)'},
        {key: 'sum_quota', label: 'Stanje udjela'},
        {key: 'number_of_request', label: 'Broj zahtjeva'},
        {key: 'edit', label: ''}
      ],
      editAsidePanelState: false,
      currentPage: 1,
      listCount: 100,
      perPage: 20,
      total: 0,
      loading: false,
      routeNames,
      aside: false,
      editAside: false,
      editTransactionObject: null,
      filter: {
        type: null,
        client_id: null,
      },
      clientSearch: {
        id: null,
        name: null
      },
      type_options: [
        {value: null, text: '-'},
        { value: 1, text: 'Kupovina' },
        { value: 2, text: 'Prodaja' },
      ],
      year_options: [
        {value: null, text: '-'},
        {value: 2023, text: '2023'},
        {value: 2022, text: '2022'},
        {value: 2021, text: '2021'},
      ],
      loader_submit: false,
      loader_reset: false,
      C_TRANSACTION_EDIT_BUTTON,
      C_TRANSACTION_NEW_BUTTON,
      C_CLIENT_SEARCH,
      items: [],
    }
  },
  components:{
    TransactionForm,
    NewButton,
    AppAside,
    AppButton,
    AppSubmit,
    SearchClient
  },
  computed: {
    ...mapGetters('client',['client'])
  },
  filters:{
    formatDate,
    formatDecimals
  },
  methods: {
    closeAndReload() {
        this.aside = false;
        this.editAside = false;
        this.editTransactionObject = null;
        this.getData();
    },
   async edit(transaction){
     this.editTransactionObject = await {...transaction, ...{ client_id: transaction.client.id }};
      this.editAside = true;
    },
    getData() {
      this.loading = true;
      if(this.clientSearch && this.clientSearch.id) {
        this.filter.client_id = this.clientSearch.id
      }
      const request = {...this.filter, ...{limit: 20, page: this.currentPage}}
      getTransactionList(request).then((response) => {
        this.items = response.data.items
        this.total = response.data.total
        this.currentPage = response.data.page
      }, (error) => {
        toast({
          'title': "Greška",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(() => {
        this.loading = false
      })
    },
    search(){
      this.getData();
    },
    resetForm(){
      this.filter = {
        type: null,
        year: null
      }
      this.clientSearch = {
        id: null,
        name: null
      }
      this.getData();
    }
  },
  beforeDestroy() {
    this.clientSearch = {id: null, name: null}
  },
  watch: {
    currentPage: {
      handler() {
        this.search();
      }
    },
    'client.id': {
      handler(value) {
        this.filter.client_id = value;
        this.search();
      }, immediate: true,
         deep: true
    }
  }
}
</script>

<style scoped>

</style>
